<template>
  <div>
    <div class="benefit-teaser-list">
      <node-benefit-teaser
        v-for="teaser in benefits?.rows"
        :key="teaser.nid"
        v-bind="teaser"
        :show-lead="true"
      />
    </div>
    <pagination
      v-if="totalPages > 1"
      :page="pageInt"
      :per-page="limit"
      :total="benefits?.totalRows"
      :is-sticky="false"
    />
  </div>
</template>

<script setup lang="ts">
import type { NodeBenefitTeaserFragment } from '#graphql-operations'

const props = defineProps<{
  tids?: [number | undefined]
}>()

const limit = ref(12)
const page = useQueryString('page', '1')
const pageInt = computed(() => parseInt(page.value) || 1)

const totalPages = computed(
  () => Math.ceil(benefits?.value?.totalRows / limit.value) ?? 0,
)

const { data: benefits } = await useAsyncData(
  async () => {
    const variables = {
      tids: 'all',
      nid: 'all',
      page: `${pageInt.value - 1}`,
      limit: limit.value,
    }

    if (props.tids?.length) {
      variables.tids = props.tids.join('+') || ''
    }
    return await useGraphqlQuery('benefitsList', variables).then((v) => {
      return {
        rows:
          // @ts-ignore
          (v.data?.entityById?.executable?.execute
            ?.rows as NodeBenefitTeaserFragment[]) || [],
        // @ts-ignore
        totalRows: v.data?.entityById?.executable?.execute.total_rows || 0,
      }
    })
  },
  {
    watch: [page],
  },
)
</script>

<style lang="scss">
.benefit-teaser-list {
  display: grid;
  grid-gap: var(--gap-v) var(--gap-h);
  margin-bottom: 3rem;
  @include tablet {
    grid-template-columns: 1fr 1fr;
  }
  @include widescreen {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>
